module.exports = __webpack_public_path__ + "static/media/iphone.fa1f973a.png";